import ConsoleApi from "apps/console/enums/consoleApi";
import { BaseApi } from "./BaseApi";
import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { ApiUrlType } from "shared/datalayer/type";

export class MyExpApiUtil extends BaseApi {
  getContactContext() {
    return MyExpApi.GET_CONTACT_CONTEXT_BY_CONTEXT_ID;
  }

  createContactContext() {
    return ConsoleApi.CREATE_CONTACT_CONTEXT;
  }

  updateContactContext() {
    return MyExpApi.UPDATE_CONTACT_CONTEXT;
  }
  getCriteriaFieldsForAccessControl() {
    return ConsoleApi.GET_CRITERIA_FIELDS_FOR_CONTACT_CONTEXT_ACCESS_CONTROL;
  }
  getCriteriaFieldsForLicensees(): ApiUrlType {
    return ConsoleApi.GET_CRITERIA_FIELDS_FOR_CONTACT_CONTEXT_LICENSEES;
  }

  getContactContextListByContactMode(): ApiUrlType {
    return MyExpApi.GET_CONTACT_CONTEXT_FOR_ADMIN;
  }
  getParticipantsToAdd(): ApiUrlType {
    return MyExpApi.GET_PARTICIPANTS_TO_ADD_IN_CONTEXT;
  }
  enableContactContext(): ApiUrlType {
    return MyExpApi.GET_PARTICIPANTS_TO_ADD_IN_CONTEXT;
  }
  updateContextStatus(): ApiUrlType {
    return "" as ApiUrlType;
  }
  downloadAttendeeList(): ApiUrlType {
    return MyExpApi.GET_PARTICIPANTS_TO_ADD_IN_CONTEXT;
  }
}
